import React from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { ResourceType } from '../../../types/resource';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarB18Link from '../../_partials/items/ActionBarB18Link';
export var OrderCommissionButton = function (_a) {
    var _b, _c, _d, _e;
    var deviation = _a.deviation, className = _a.className;
    var t = useTranslation().t;
    var isOpen = (_c = (_b = deviation.commission) === null || _b === void 0 ? void 0 : _b.isActive) !== null && _c !== void 0 ? _c : false;
    var checkoutLink = ((_d = deviation.commission) === null || _d === void 0 ? void 0 : _d.subproductId)
        ? Url.checkoutLink((_e = deviation.commission) === null || _e === void 0 ? void 0 : _e.subproductId)
        : undefined;
    return (React.createElement(ActionBarItemWrapper, { className: className },
        React.createElement(ActionBarB18Link, { href: checkoutLink, disabled: !isOpen, biData: {
                evid: BiEventType.PROFILE_ORDER_COMMISSION,
                typeid: ResourceType.COMMISSION,
                itemid: get(deviation, 'commission.commissionId'),
                points: get(deviation, 'commission.pointsCost'),
                creatorid: get(deviation, 'author.useridUuid'),
            } }, t(isOpen ? 'actionbar.orderCommission' : 'actionbar.closedCommission'))));
};
OrderCommissionButton.displayName = 'OrderCommissionButton';
export default OrderCommissionButton;
//# sourceMappingURL=OrderCommissionButton.js.map